import { render, staticRenderFns } from "./MediaViewer.vue?vue&type=template&id=50f915b6&scoped=true&lang=pug"
import script from "./MediaViewer.vue?vue&type=script&lang=js"
export * from "./MediaViewer.vue?vue&type=script&lang=js"
import style0 from "./MediaViewer.vue?vue&type=style&index=0&id=50f915b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f915b6",
  null
  
)

export default component.exports